__turbopack_context__.v({
  "arrowBtn": "partners-module__DSO1DW__arrowBtn",
  "bringCard1": "partners-module__DSO1DW__bringCard1",
  "bringCard2": "partners-module__DSO1DW__bringCard2",
  "bringCard3": "partners-module__DSO1DW__bringCard3",
  "bringCard4": "partners-module__DSO1DW__bringCard4",
  "bringCard5": "partners-module__DSO1DW__bringCard5",
  "bringCard6": "partners-module__DSO1DW__bringCard6",
  "bringHeader": "partners-module__DSO1DW__bringHeader",
  "bringHeaderText": "partners-module__DSO1DW__bringHeaderText",
  "bringSection": "partners-module__DSO1DW__bringSection",
  "certDivider": "partners-module__DSO1DW__certDivider",
  "certIcon": "partners-module__DSO1DW__certIcon",
  "certItem": "partners-module__DSO1DW__certItem",
  "certsStrip": "partners-module__DSO1DW__certsStrip",
  "certsStripHeading": "partners-module__DSO1DW__certsStripHeading",
  "certsStripInner": "partners-module__DSO1DW__certsStripInner",
  "certsStripItems": "partners-module__DSO1DW__certsStripItems",
  "credAvatar": "partners-module__DSO1DW__credAvatar",
  "credDemoBlock": "partners-module__DSO1DW__credDemoBlock",
  "credDemoHint": "partners-module__DSO1DW__credDemoHint",
  "credDemoLabel": "partners-module__DSO1DW__credDemoLabel",
  "credDemoPhone": "partners-module__DSO1DW__credDemoPhone",
  "credDotActive": "partners-module__DSO1DW__credDotActive",
  "credLabel": "partners-module__DSO1DW__credLabel",
  "credName": "partners-module__DSO1DW__credName",
  "credPending": "partners-module__DSO1DW__credPending",
  "credPulse": "partners-module__DSO1DW__credPulse",
  "credRow": "partners-module__DSO1DW__credRow",
  "credRows": "partners-module__DSO1DW__credRows",
  "credStatus": "partners-module__DSO1DW__credStatus",
  "credValue": "partners-module__DSO1DW__credValue",
  "credVerified": "partners-module__DSO1DW__credVerified",
  "credWidget": "partners-module__DSO1DW__credWidget",
  "credWidgetHeader": "partners-module__DSO1DW__credWidgetHeader",
  "credWidgetInfo": "partners-module__DSO1DW__credWidgetInfo",
  "ctaBtn": "partners-module__DSO1DW__ctaBtn",
  "ctaImage": "partners-module__DSO1DW__ctaImage",
  "ctaInner": "partners-module__DSO1DW__ctaInner",
  "ctaOverlay": "partners-module__DSO1DW__ctaOverlay",
  "ctaSection": "partners-module__DSO1DW__ctaSection",
  "ctaSubtitle": "partners-module__DSO1DW__ctaSubtitle",
  "ctaTitle": "partners-module__DSO1DW__ctaTitle",
  "demoCallBtn": "partners-module__DSO1DW__demoCallBtn",
  "demoCard": "partners-module__DSO1DW__demoCard",
  "demoCardBg": "partners-module__DSO1DW__demoCardBg",
  "demoCardContent": "partners-module__DSO1DW__demoCardContent",
  "demoCardDesc": "partners-module__DSO1DW__demoCardDesc",
  "demoCardOverlay": "partners-module__DSO1DW__demoCardOverlay",
  "demoCardTitle": "partners-module__DSO1DW__demoCardTitle",
  "demoCards": "partners-module__DSO1DW__demoCards",
  "demoEyebrow": "partners-module__DSO1DW__demoEyebrow",
  "demoHeader": "partners-module__DSO1DW__demoHeader",
  "demoLiveDot": "partners-module__DSO1DW__demoLiveDot",
  "demoLivePill": "partners-module__DSO1DW__demoLivePill",
  "demoPhoneNum": "partners-module__DSO1DW__demoPhoneNum",
  "demoSection": "partners-module__DSO1DW__demoSection",
  "demoSubtitle": "partners-module__DSO1DW__demoSubtitle",
  "demoTitle": "partners-module__DSO1DW__demoTitle",
  "fcIllusArea": "partners-module__DSO1DW__fcIllusArea",
  "fcPulse": "partners-module__DSO1DW__fcPulse",
  "fcSubtitle": "partners-module__DSO1DW__fcSubtitle",
  "fcTextArea": "partners-module__DSO1DW__fcTextArea",
  "fcTitle": "partners-module__DSO1DW__fcTitle",
  "fcWave": "partners-module__DSO1DW__fcWave",
  "featureCard": "partners-module__DSO1DW__featureCard",
  "featuresGrid": "partners-module__DSO1DW__featuresGrid",
  "featuresInner": "partners-module__DSO1DW__featuresInner",
  "featuresSection": "partners-module__DSO1DW__featuresSection",
  "hero": "partners-module__DSO1DW__hero",
  "heroBtnPrimary": "partners-module__DSO1DW__heroBtnPrimary",
  "heroBtnSecondary": "partners-module__DSO1DW__heroBtnSecondary",
  "heroBtns": "partners-module__DSO1DW__heroBtns",
  "heroContent": "partners-module__DSO1DW__heroContent",
  "heroImage": "partners-module__DSO1DW__heroImage",
  "heroLayout": "partners-module__DSO1DW__heroLayout",
  "heroOverlay": "partners-module__DSO1DW__heroOverlay",
  "heroSubtitle": "partners-module__DSO1DW__heroSubtitle",
  "heroTag": "partners-module__DSO1DW__heroTag",
  "heroTitle": "partners-module__DSO1DW__heroTitle",
  "howItWorksHeader": "partners-module__DSO1DW__howItWorksHeader",
  "howItWorksSection": "partners-module__DSO1DW__howItWorksSection",
  "howSubtitle": "partners-module__DSO1DW__howSubtitle",
  "howTitle": "partners-module__DSO1DW__howTitle",
  "howTitleItalic": "partners-module__DSO1DW__howTitleItalic",
  "illusAgreementBadge": "partners-module__DSO1DW__illusAgreementBadge",
  "illusAgreementCard": "partners-module__DSO1DW__illusAgreementCard",
  "illusAgreementIcon": "partners-module__DSO1DW__illusAgreementIcon",
  "illusAgreementParties": "partners-module__DSO1DW__illusAgreementParties",
  "illusAgreementTitle": "partners-module__DSO1DW__illusAgreementTitle",
  "illusApiBadge": "partners-module__DSO1DW__illusApiBadge",
  "illusApiMethod": "partners-module__DSO1DW__illusApiMethod",
  "illusApiPath": "partners-module__DSO1DW__illusApiPath",
  "illusApiRow": "partners-module__DSO1DW__illusApiRow",
  "illusApiTitle": "partners-module__DSO1DW__illusApiTitle",
  "illusApiWrap": "partners-module__DSO1DW__illusApiWrap",
  "illusAwardBadge": "partners-module__DSO1DW__illusAwardBadge",
  "illusAwardRow": "partners-module__DSO1DW__illusAwardRow",
  "illusAwardWrap": "partners-module__DSO1DW__illusAwardWrap",
  "illusCallBadge": "partners-module__DSO1DW__illusCallBadge",
  "illusCallDot": "partners-module__DSO1DW__illusCallDot",
  "illusCallNumber": "partners-module__DSO1DW__illusCallNumber",
  "illusCallWrap": "partners-module__DSO1DW__illusCallWrap",
  "illusCapCard": "partners-module__DSO1DW__illusCapCard",
  "illusCapRow": "partners-module__DSO1DW__illusCapRow",
  "illusCapTitle": "partners-module__DSO1DW__illusCapTitle",
  "illusCapVerified": "partners-module__DSO1DW__illusCapVerified",
  "illusCodeBadge": "partners-module__DSO1DW__illusCodeBadge",
  "illusCodeCls": "partners-module__DSO1DW__illusCodeCls",
  "illusCodeComment": "partners-module__DSO1DW__illusCodeComment",
  "illusCodeFn": "partners-module__DSO1DW__illusCodeFn",
  "illusCodeKw": "partners-module__DSO1DW__illusCodeKw",
  "illusCodeLine": "partners-module__DSO1DW__illusCodeLine",
  "illusCodeTitle": "partners-module__DSO1DW__illusCodeTitle",
  "illusCodeWrap": "partners-module__DSO1DW__illusCodeWrap",
  "illusContractBadge": "partners-module__DSO1DW__illusContractBadge",
  "illusContractDot": "partners-module__DSO1DW__illusContractDot",
  "illusContractGreen": "partners-module__DSO1DW__illusContractGreen",
  "illusContractRow": "partners-module__DSO1DW__illusContractRow",
  "illusContractTitle": "partners-module__DSO1DW__illusContractTitle",
  "illusContractWrap": "partners-module__DSO1DW__illusContractWrap",
  "illusEnterpriseActive": "partners-module__DSO1DW__illusEnterpriseActive",
  "illusEnterpriseName": "partners-module__DSO1DW__illusEnterpriseName",
  "illusEnterprisePending": "partners-module__DSO1DW__illusEnterprisePending",
  "illusEnterpriseRow": "partners-module__DSO1DW__illusEnterpriseRow",
  "illusEnterpriseTitle": "partners-module__DSO1DW__illusEnterpriseTitle",
  "illusEnterpriseWrap": "partners-module__DSO1DW__illusEnterpriseWrap",
  "illusFormBadge": "partners-module__DSO1DW__illusFormBadge",
  "illusFormCard": "partners-module__DSO1DW__illusFormCard",
  "illusFormRow": "partners-module__DSO1DW__illusFormRow",
  "illusFormTitle": "partners-module__DSO1DW__illusFormTitle",
  "illusFraudAlert": "partners-module__DSO1DW__illusFraudAlert",
  "illusFraudBlock": "partners-module__DSO1DW__illusFraudBlock",
  "illusFraudNum": "partners-module__DSO1DW__illusFraudNum",
  "illusFraudRow": "partners-module__DSO1DW__illusFraudRow",
  "illusFraudScore": "partners-module__DSO1DW__illusFraudScore",
  "illusFraudScoreLabel": "partners-module__DSO1DW__illusFraudScoreLabel",
  "illusFraudTitle": "partners-module__DSO1DW__illusFraudTitle",
  "illusFraudWrap": "partners-module__DSO1DW__illusFraudWrap",
  "illusIndustryBadge": "partners-module__DSO1DW__illusIndustryBadge",
  "illusIndustryIcon": "partners-module__DSO1DW__illusIndustryIcon",
  "illusIndustryName": "partners-module__DSO1DW__illusIndustryName",
  "illusIndustryRow": "partners-module__DSO1DW__illusIndustryRow",
  "illusIndustryWrap": "partners-module__DSO1DW__illusIndustryWrap",
  "illusLlmMeta": "partners-module__DSO1DW__illusLlmMeta",
  "illusLlmPrompt": "partners-module__DSO1DW__illusLlmPrompt",
  "illusLlmResponse": "partners-module__DSO1DW__illusLlmResponse",
  "illusLlmTitle": "partners-module__DSO1DW__illusLlmTitle",
  "illusLlmWrap": "partners-module__DSO1DW__illusLlmWrap",
  "illusTeamingArrow": "partners-module__DSO1DW__illusTeamingArrow",
  "illusTeamingBadge": "partners-module__DSO1DW__illusTeamingBadge",
  "illusTeamingRow": "partners-module__DSO1DW__illusTeamingRow",
  "illusTeamingTitle": "partners-module__DSO1DW__illusTeamingTitle",
  "illusTeamingWrap": "partners-module__DSO1DW__illusTeamingWrap",
  "illusVisionBox": "partners-module__DSO1DW__illusVisionBox",
  "illusVisionDetectA": "partners-module__DSO1DW__illusVisionDetectA",
  "illusVisionDetectB": "partners-module__DSO1DW__illusVisionDetectB",
  "illusVisionGrid": "partners-module__DSO1DW__illusVisionGrid",
  "illusVisionLabel": "partners-module__DSO1DW__illusVisionLabel",
  "illusVisionTitle": "partners-module__DSO1DW__illusVisionTitle",
  "illusVisionWrap": "partners-module__DSO1DW__illusVisionWrap",
  "illusWaveBar": "partners-module__DSO1DW__illusWaveBar",
  "illusWaveBars": "partners-module__DSO1DW__illusWaveBars",
  "illusWinBadge": "partners-module__DSO1DW__illusWinBadge",
  "illusWinCard": "partners-module__DSO1DW__illusWinCard",
  "illusWinDot": "partners-module__DSO1DW__illusWinDot",
  "illusWinList": "partners-module__DSO1DW__illusWinList",
  "livePulse": "partners-module__DSO1DW__livePulse",
  "page": "partners-module__DSO1DW__page",
  "sectionHeader": "partners-module__DSO1DW__sectionHeader",
  "sectionLabel": "partners-module__DSO1DW__sectionLabel",
  "slideCard": "partners-module__DSO1DW__slideCard",
  "slideCard1": "partners-module__DSO1DW__slideCard1",
  "slideCard2": "partners-module__DSO1DW__slideCard2",
  "slideCard3": "partners-module__DSO1DW__slideCard3",
  "slideCard4": "partners-module__DSO1DW__slideCard4",
  "slideDesc": "partners-module__DSO1DW__slideDesc",
  "slideIllus": "partners-module__DSO1DW__slideIllus",
  "slideNum": "partners-module__DSO1DW__slideNum",
  "slideText": "partners-module__DSO1DW__slideText",
  "slideTitle": "partners-module__DSO1DW__slideTitle",
  "sliderArrows": "partners-module__DSO1DW__sliderArrows",
  "sliderViewport": "partners-module__DSO1DW__sliderViewport",
});
